module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data03-3367b4b4d8e61ce97164d774e046a65f.png";